export default {
    title: "Itens não entregues",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Obrigado",
        message: "Obrigado pela sua resposta."
    },
    message: "Você indicou que não recebeu seu item, apesar da transportadora tê-lo marcado como entregue.",
    cta: "Siga estas etapas para nos ajudar a solucionar o problema:",
    items: {
        1: {
            message: "Clique no(s) link(s) de rastreamento:"
        },
        2: {
            message: "Revise o status da entrega. Verifique:",
            items: {
                1: "Quem assinou o pacote",
                2: "Se foi devolvido ao remetente",
                3: "Se a encomenda estiver aguardando retirada"
            }
        },
        3: {
            message: "Verifique se há um aviso de entrega indicando onde o item pode ter sido deixado."
        },
        4: {
            message: "Verifique com vizinhos, parentes e amigos que possam ter levado o pacote."
        }
    },
    question: "Isso ajudou a resolver sua dúvida sobre entrega? Você já tem o item ou sabe quem o tem? Responda abaixo.",
    product: {
        name: "Nome do item",
        quantity: "Quantidade",
        tracking: "Monitorando",
    },
    buttons: {
        yes: "Sim",
        no: "Não",
        saving: "Salvando"
    }
}